import {createFileRoute, notFound} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {PendingComponent} from "./-pendingComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {RouteComponent} from "./-routeComponent";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {
    PaymentGateway,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/subscriptionWorkspaceCapability/domain/PaymentGateway";
import {
    paymentSessionZodValidator,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/subscriptionWorkspaceCapability/domain/PaymentSession";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/p/test-gateway/$paymentSessionId")({
    loader: async ({context, params}) => {
        if (["dev", "local", "test", "simulation"].includes(context.environment) !== true) {
            throw notFound();
        }

        const paymentSessionIdResult = uuidZodValidator.safeParse(params.paymentSessionId);
        if (paymentSessionIdResult.success !== true) {
            throw notFound();
        }
        const paymentSessionId = paymentSessionIdResult.data;

        const paymentSessionResult = await robustJsonResultClientFetch(
            `${context.intellsysBaseUrl}/sub-system/pluto/p/get-payment-session-details`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({
                    paymentSessionId: paymentSessionId,
                }),
            },
            paymentSessionZodValidator,
        );
        if (paymentSessionResult.success !== true) {
            throw paymentSessionResult.error;
        }
        if (paymentSessionResult.data.paymentDetails.paymentGateway !== PaymentGateway.dummy) {
            throw notFound();
        }

        return {
            paymentSession: paymentSessionResult.data,
            paymentSessionId: paymentSessionId,
            intellsysBaseUrl: context.intellsysBaseUrl,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
